import { render, staticRenderFns } from "./classExample.vue?vue&type=template&id=5956c8fc&scoped=true&"
import script from "./classExample.vue?vue&type=script&lang=js&"
export * from "./classExample.vue?vue&type=script&lang=js&"
import style0 from "./classExample.vue?vue&type=style&index=0&id=5956c8fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5956c8fc",
  null
  
)

export default component.exports